import React, { Fragment } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import ReactJson from "react-json-view";

export function DetailsModal({
  show,
  onModalClose,
  selectedLog,
  detailsModalHeader,
}) {
  return (
    <Modal
      show={show}
      onHide={onModalClose}
      dialogClassName="modal-xl"
      backdrop="static"
    >
      <Modal.Header>
        <Button
          className="close"
          data-dismiss="modal"
          aria-label="Close"
          onClick={onModalClose}
        >
          <span aria-hidden="true">&times;</span>
        </Button>
        <Modal.Title>Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col sm={12}>
            <Header
              detailsModalHeader={detailsModalHeader}
              selectedLog={selectedLog}
            />
          </Col>
        </Row>
        <hr />
        <Row>
          <Col sm={6}>
            <ReactJson
              src={selectedLog.oldValues}
              displayDataTypes={false}
              displayObjectSize={false}
              name="oldValues"
            />
          </Col>
          <Col sm={6}>
            <ReactJson
              src={selectedLog.newValues}
              displayDataTypes={false}
              displayObjectSize={false}
              name="newValues"
            />
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <button onClick={onModalClose} className="btn btn-grey">
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
}

function Header({ detailsModalHeader, selectedLog }) {
  return (
    <dl className="dl-horizontal">
      {detailsModalHeader &&
        detailsModalHeader.map((detail) => (
          <Fragment>
            <dt>{detail.label}</dt>
            <dd>
              {detail.formatter
                ? detail.formatter(selectedLog[detail.value])
                : selectedLog[detail.value]}
            </dd>
          </Fragment>
        ))}
    </dl>
  );
}
